import { render, staticRenderFns } from "./PropertiesPaymentViewGlobal.vue?vue&type=template&id=3e7fb966"
import script from "./PropertiesPaymentViewGlobal.vue?vue&type=script&lang=js"
export * from "./PropertiesPaymentViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports